function init() {

    const menu = document.querySelector( '.desktop-header-main-menu' );
    if ( ! menu ) return;

    const toggleButtons = menu.querySelectorAll( ':scope > div > button[aria-expanded]' );

    function closeAllSubmenus( except = null ) {
        toggleButtons.forEach( btn => {
            if ( btn !== except ) {
                btn.setAttribute( 'aria-expanded', 'false' );
                const submenu = btn.nextElementSibling;
                if ( submenu ) submenu.classList.remove( 'nav-sub-menu--align-right' );
            }
        });
    }

    function alignSubmenu( submenu ) {
        submenu.classList.remove( 'nav-sub-menu--align-right' );
        const rect = submenu.getBoundingClientRect();
        if ( rect.right > window.innerWidth ) {
            submenu.classList.add( 'nav-sub-menu--align-right' );
        }
    }

    function toggleSubmenu( button ) {
        const isOpen = button.getAttribute( 'aria-expanded' ) === 'true';
        closeAllSubmenus( button );
        button.setAttribute( 'aria-expanded', String( ! isOpen ) );

        if ( ! isOpen ) {
            const submenu = button.nextElementSibling;
            if ( submenu ) alignSubmenu( submenu );
        }
    }

    // Toggle on button click, close sibling submenus on focus
    toggleButtons.forEach( button => {
        button.addEventListener( 'click', () => toggleSubmenu( button ) );
        button.addEventListener( 'focus', () => closeAllSubmenus( button ) );
    });

    // Close on click outside the menu container
    document.addEventListener( 'click', ( e ) => {
        if ( ! menu.contains( e.target ) ) closeAllSubmenus();
    });

    // Keyboard handling
    menu.addEventListener( 'keydown', ( e ) => {

        const activeButton = [ ...toggleButtons ].find(
            btn => btn.getAttribute( 'aria-expanded' ) === 'true'
        );

        // Escape closes the open submenu and returns focus to its button
        if ( e.key === 'Escape' && activeButton ) {
            e.preventDefault();
            activeButton.setAttribute( 'aria-expanded', 'false' );
            activeButton.focus();
        }

        // Arrow down from an open button moves focus into the first submenu link
        if ( e.key === 'ArrowDown' && activeButton && document.activeElement === activeButton ) {
            const submenu = activeButton.nextElementSibling;
            const firstLink = submenu ? submenu.querySelector( 'a' ) : null;
            if ( firstLink ) {
                e.preventDefault();
                firstLink.focus();
            }
        }

        // Arrow up from the first submenu link returns focus to the button
        if ( e.key === 'ArrowUp' && activeButton ) {
            const submenu = activeButton.nextElementSibling;
            const links = submenu ? [ ...submenu.querySelectorAll( 'a' ) ] : [];
            if ( document.activeElement === links[ 0 ] ) {
                e.preventDefault();
                activeButton.focus();
            }
        }

    });

}

const api = {
    init: init
}

export default api;
